module.exports = "pegasus_template/assets/themecapture1/ebook/108.png";